import * as d3 from 'd3';

import { ticketAssignedColor, ticketClosedColor, ticketCompletedColor, ticketNewColor, ticketRejectedColor } from '../../../common';

export const colorScale = d3.scale.ordinal<string, string>()
    .domain(['New', 'Assigned', 'Completed', 'Rejected', 'Closed'])
    .range([ticketNewColor, ticketAssignedColor, ticketCompletedColor, ticketRejectedColor, ticketClosedColor]);